import {TextLinkWidget} from '@tableau/widgets';
import React from 'react';

import {openReactActionDialog} from '~commonInfra/dialogs/ReactActionDialog';
import {TabDialogWidth} from '~commonInfra/dialogs/style/TabDialogWidth';
import {HelpService} from '~commonInfra/services/HelpService';
import {Messages} from '~src/codegen/Localize';
import {
  KMS_IN_ONLINE_ENABLEMENT_INFO_LINK
} from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';
import {learnMoreStyle} from '~src/settings/styles/CommonStyles';

/**
 * Generate dialog to ask user to confirm whether to encrypt extracts.
 */
export function encryptionConfirmationDialog(): Promise<any> {
  return openReactActionDialog({
    dismissDialogOnActionFailed: false,
    initialBodyProps: undefined,
    initialDialogState: undefined,
    title: Messages.extractEncryptionTOLEnableEncryptionPrompt(),
    bodyComponent: encryptionConfirmationDialogBody,
    actionName: Messages.extractEncryptionTOLEnableEncryptionConfirmation(),
    action: () => Promise.resolve(),
    dialogWidth: TabDialogWidth.width500px,
    showCloseButton: true,
    hideCancelButton: true,
  }).result;
}

export function encryptionConfirmationDialogBody(): JSX.Element {
  return <div>
    <span>{Messages.extractEncryptionTOLEnableEncryptionDialog()}</span>
    <TextLinkWidget testId={KMS_IN_ONLINE_ENABLEMENT_INFO_LINK}
                    href={HelpService.getServerHelpUrlByCategory('customer-managed-encryption-keys')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={learnMoreStyle}
    >
      {Messages.learnMore()}
    </TextLinkWidget>
  </div>;
}